"use client";

import { useEffect } from "react";

export default function ScrollbarVisibility() {
  useEffect(() => {
    const root = document.documentElement;
    let hideTimeout: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      root.classList.add("is-scrolling");
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        root.classList.remove("is-scrolling");
      }, 1000);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(hideTimeout);
    };
  }, []);

  return null;
}
